import React, { useEffect } from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import SectorSection from '../components/SectorSection';
import AboutSection from '../components/AboutSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import { mockData } from '../mock';

const HomePage = () => {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      
      <AboutSection />
      
      {/* HVAC Section */}
      <SectorSection
        id="hvac"
        title="HVAC Solutions"
        description={mockData.sectors.hvac.description}
        subsections={mockData.sectors.hvac.subsections}
        images={mockData.sectors.hvac.images}
        sectorLink="hvac"
        accentColor="red"
      />
      
      {/* Electrical Section */}
      <SectorSection
        id="electrical"
        title="Electrical Services"
        description={mockData.sectors.electrical.description}
        subsections={mockData.sectors.electrical.subsections}
        images={mockData.sectors.electrical.images}
        sectorLink="electrical"
        accentColor="blue"
      />
      
      {/* Door Automation Section */}
      <SectorSection
        id="door-automation"
        title="Door Automation"
        description={mockData.sectors.doorAutomation.description}
        subsections={mockData.sectors.doorAutomation.subsections}
        images={mockData.sectors.doorAutomation.images}
        sectorLink="door-automation"
        accentColor="gray"
      />
      
      <TestimonialsSection testimonials={mockData.testimonials} />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;